/** Recorded active time survives recovery. Offline time is not GM work. */
export function recordedTurnElapsed(input:{elapsedMs:number;priorWorkMs?:number | undefined;priorWaitMs?:number | undefined;waitMs:number;activeWaitMs:number;confirmedWaitMs?:number}) {
  const nonnegative=(value:number|undefined)=>typeof value==='number'&&Number.isFinite(value)?Math.max(0,value):0;
  const priorWork=nonnegative(input.priorWorkMs),priorWait=nonnegative(input.priorWaitMs);
  const wait=Math.max(priorWait,nonnegative(input.waitMs))+nonnegative(input.activeWaitMs);
  const work=priorWork+Math.max(0,nonnegative(input.elapsedMs)-(wait-priorWait));
  const workMs=Math.round(work),waitMs=Math.round(Math.max(wait,nonnegative(input.confirmedWaitMs)));
  return {workMs,waitMs,totalMs:workMs+waitMs};
}

/** SQL stores these timestamps in UTC, including older values without a suffix. */
export function confirmedPlayerWait(roll:{requestedAt?:string;resolvedAt?:string}):number {
  const utc=(value:string|undefined)=>!value?NaN:Date.parse(/[zZ]|[+-]\d\d:\d\d$/.test(value)?value:`${value}Z`);
  const duration=utc(roll.resolvedAt)-utc(roll.requestedAt);
  return Number.isFinite(duration)&&duration>=0?duration:0;
}
